import axios from "axios";
import { NetworkUtils } from "./NetworkUtils";
import NetworkErrorHandler from "./NetworkErrorHandler";
import { APILogger } from "../../utils/Logger";

export class BaseAPICallsHandler {
    
    public static shared = new BaseAPICallsHandler() 
    private errorHandler = new NetworkErrorHandler()

    public async makeGetRequest(headers: any, url: string)  : Promise<{data: any}> {
        try {
            let requestHeaders = NetworkUtils.shared.addCommonHeaders(headers);

            const response = await axios({
                method: 'get',
                headers: requestHeaders,
                url: url,
              });
    
            APILogger.log('GET', url, null, response.data);
            return Promise.resolve(response.data)
    
        } catch (error: any) {
            APILogger.error('GET', url, null, error);
            const errorMessage = this.errorHandler.handleError(error);
            return Promise.reject(errorMessage);
        }
    }
    
    public async makePostRequest(headers: any, url: string, body: any) : Promise<{data: any, message?: string}> {
        try {
            let requestHeaders = NetworkUtils.shared.addCommonHeaders(headers);

            const response = await axios({
                method: 'post',
                headers: requestHeaders,
                url: url,
                data: body
              });
    
            APILogger.log('POST', url, body, response.data);
            return Promise.resolve(response.data)
    
        } catch (error: any) {
            APILogger.error('POST', url, body, error);
            const errorMessage = this.errorHandler.handleError(error);
            return Promise.reject(errorMessage);
        }
    }
    
    public async makePutRequest(headers: any, url: string, body : any) : Promise<{data: any}> {
        try {
            let requestHeaders = NetworkUtils.shared.addCommonHeaders(headers);

            const response = await axios({
                method: 'put',
                headers: requestHeaders,
                url: url,
                data: body
              });
    
            APILogger.log('PUT', url, body, response.data);
            return Promise.resolve(response.data)
    
        } catch (error: any) {
            APILogger.error('PUT', url, body, error);
            const errorMessage = this.errorHandler.handleError(error);
            return Promise.reject(errorMessage);
        }
    }
    
    public async makePatchRequest(headers: any, url: string, body : any) : Promise<{data: any}> {
        try {
            let requestHeaders = NetworkUtils.shared.addCommonHeaders(headers);

            const response = await axios({
                method: 'patch',
                headers: requestHeaders,
                url: url,
                data: body
              });
    
            APILogger.log('PATCH', url, body, response.data);
            return Promise.resolve(response.data)
    
        } catch (error: any) {
            APILogger.error('PATCH', url, body, error);
            const errorMessage = this.errorHandler.handleError(error);
            return Promise.reject(errorMessage);
        }
    }
    
    public async makeDeleteRequest(headers: any, url: string, body : any) : Promise<{data: any}> {
        try {
            let requestHeaders = NetworkUtils.shared.addCommonHeaders(headers);

            const response = await axios({
                method: 'delete',
                headers: requestHeaders,
                url: url,
                data: body
              });
    
            APILogger.log('DELETE', url, body, response.data);
            return Promise.resolve(response.data)
    
        } catch (error: any) {
            APILogger.error('DELETE', url, body, error);
            const errorData = error.response.data;
            
            // handle error passing if API fails
            if (errorData !== undefined)    // for error recieved from server
                return Promise.reject(errorData.message)
            return Promise.reject(error.message);   // for error generated by axios
        }
    }
    
}   